export default "__VITE_ASSET__BpUUzuCL__"